const routes =  {
  "data": [
    {
      "GEOID": "24510260605",
      "itineraries": {
        "legs": [
          {
            "mode": "WALK",
            "startTime": 1729614614000,
            "endTime": 1729615023000,
            "from": {
              "lat": 39.2746347,
              "lon": -76.5369696,
              "departureTime": 1729614614000,
              "arrivalTime": 1729614614000
            },
            "to": {
              "lat": 39.274976,
              "lon": -76.531945,
              "departureTime": 1729615023000,
              "arrivalTime": 1729615023000
            }
          },
          {
            "mode": "BUS",
            "startTime": 1729615023000,
            "endTime": 1729617060000,
            "from": {
              "lat": 39.274976,
              "lon": -76.531945,
              "departureTime": 1729615023000,
              "arrivalTime": 1729615023000
            },
            "to": {
              "lat": 39.287503,
              "lon": -76.623267,
              "departureTime": 1729617060000,
              "arrivalTime": 1729617060000
            }
          },
          {
            "mode": "WALK",
            "startTime": 1729617060000,
            "endTime": 1729617091000,
            "from": {
              "lat": 39.287503,
              "lon": -76.623267,
              "departureTime": 1729617060000,
              "arrivalTime": 1729617060000
            },
            "to": {
              "lat": 39.28749,
              "lon": -76.62375,
              "departureTime": 1729617091000,
              "arrivalTime": 1729617091000
            }
          }
        ]
      }
    },
    {
      "GEOID": "24510250205",
      "itineraries": {
        "legs": [
          {
            "mode": "WALK",
            "startTime": 1729615315000,
            "endTime": 1729615833000,
            "from": {
              "lat": 39.2553308,
              "lon": -76.6513199,
              "departureTime": 1729615315000,
              "arrivalTime": 1729615315000
            },
            "to": {
              "lat": 39.253446,
              "lon": -76.646547,
              "departureTime": 1729615833000,
              "arrivalTime": 1729615833000
            }
          },
          {
            "mode": "BUS",
            "startTime": 1729615833000,
            "endTime": 1729616727000,
            "from": {
              "lat": 39.253446,
              "lon": -76.646547,
              "departureTime": 1729615833000,
              "arrivalTime": 1729615833000
            },
            "to": {
              "lat": 39.287699,
              "lon": -76.622083,
              "departureTime": 1729616727000,
              "arrivalTime": 1729616727000
            }
          },
          {
            "mode": "WALK",
            "startTime": 1729616727000,
            "endTime": 1729616854000,
            "from": {
              "lat": 39.287699,
              "lon": -76.622083,
              "departureTime": 1729616727000,
              "arrivalTime": 1729616727000
            },
            "to": {
              "lat": 39.28749,
              "lon": -76.62375,
              "departureTime": 1729616854000,
              "arrivalTime": 1729616854000
            }
          }
        ]
      }
    },
    {
      "GEOID": "24510150100",
      "itineraries": {
        "legs": [
          {
            "mode": "WALK",
            "startTime": 1729614867000,
            "endTime": 1729615176000,
            "from": {
              "lat": 39.305899,
              "lon": -76.6411674,
              "departureTime": 1729614867000,
              "arrivalTime": 1729614867000
            },
            "to": {
              "lat": 39.305287,
              "lon": -76.644373,
              "departureTime": 1729615176000,
              "arrivalTime": 1729615176000
            }
          },
          {
            "mode": "BUS",
            "startTime": 1729615176000,
            "endTime": 1729616040000,
            "from": {
              "lat": 39.305287,
              "lon": -76.644373,
              "departureTime": 1729615176000,
              "arrivalTime": 1729615176000
            },
            "to": {
              "lat": 39.286106,
              "lon": -76.623708,
              "departureTime": 1729616040000,
              "arrivalTime": 1729616040000
            }
          },
          {
            "mode": "WALK",
            "startTime": 1729616040000,
            "endTime": 1729616162000,
            "from": {
              "lat": 39.286106,
              "lon": -76.623708,
              "departureTime": 1729616040000,
              "arrivalTime": 1729616040000
            },
            "to": {
              "lat": 39.28749,
              "lon": -76.62375,
              "departureTime": 1729616162000,
              "arrivalTime": 1729616162000
            }
          }
        ]
      }
    },
    {
      "GEOID": "24510120400",
      "itineraries": {
        "legs": [
          {
            "mode": "WALK",
            "startTime": 1729615217000,
            "endTime": 1729615487000,
            "from": {
              "lat": 39.3157094,
              "lon": -76.6118534,
              "departureTime": 1729615217000,
              "arrivalTime": 1729615217000
            },
            "to": {
              "lat": 39.314624,
              "lon": -76.609613,
              "departureTime": 1729615487000,
              "arrivalTime": 1729615487000
            }
          },
          {
            "mode": "BUS",
            "startTime": 1729615487000,
            "endTime": 1729616820000,
            "from": {
              "lat": 39.314624,
              "lon": -76.609613,
              "departureTime": 1729615487000,
              "arrivalTime": 1729615487000
            },
            "to": {
              "lat": 39.289133,
              "lon": -76.623864,
              "departureTime": 1729616820000,
              "arrivalTime": 1729616820000
            }
          },
          {
            "mode": "WALK",
            "startTime": 1729616820000,
            "endTime": 1729616993000,
            "from": {
              "lat": 39.289133,
              "lon": -76.623864,
              "departureTime": 1729616820000,
              "arrivalTime": 1729616820000
            },
            "to": {
              "lat": 39.28749,
              "lon": -76.62375,
              "departureTime": 1729616993000,
              "arrivalTime": 1729616993000
            }
          }
        ]
      }
    },
    {
      "GEOID": "24510151200",
      "itineraries": {
        "startTime": 1729647046000,
        "endTime": 1729649018000,
        "legs": [
          {
            "mode": "WALK",
            "startTime": 1729647046000,
            "endTime": 1729647139000,
            "from": {
              "lat": 39.3308678,
              "lon": -76.6621895,
              "departureTime": 1729647046000,
              "arrivalTime": 1729647046000
            },
            "to": {
              "lat": 39.331463,
              "lon": -76.662267,
              "departureTime": 1729647139000,
              "arrivalTime": 1729647139000
            }
          },
          {
            "mode": "BUS",
            "startTime": 1729647139000,
            "endTime": 1729647360000,
            "from": {
              "lat": 39.331463,
              "lon": -76.662267,
              "departureTime": 1729647139000,
              "arrivalTime": 1729647139000
            },
            "to": {
              "lat": 39.317777,
              "lon": -76.652235,
              "departureTime": 1729647360000,
              "arrivalTime": 1729647360000
            }
          },
          {
            "mode": "WALK",
            "startTime": 1729647360000,
            "endTime": 1729647543000,
            "from": {
              "lat": 39.317777,
              "lon": -76.652235,
              "departureTime": 1729647360000,
              "arrivalTime": 1729647360000
            },
            "to": {
              "lat": 39.318333,
              "lon": -76.653735,
              "departureTime": 1729647543000,
              "arrivalTime": 1729647543000
            }
          },
          {
            "mode": "SUBWAY",
            "startTime": 1729647910000,
            "endTime": 1729648320000,
            "from": {
              "lat": 39.318333,
              "lon": -76.653735,
              "departureTime": 1729647910000,
              "arrivalTime": 1729647910000
            },
            "to": {
              "lat": 39.290968,
              "lon": -76.620923,
              "departureTime": 1729648320000,
              "arrivalTime": 1729648320000
            }
          },
          {
            "mode": "WALK",
            "startTime": 1729648320000,
            "endTime": 1729649018000,
            "from": {
              "lat": 39.290968,
              "lon": -76.620923,
              "departureTime": 1729648320000,
              "arrivalTime": 1729648320000
            },
            "to": {
              "lat": 39.28749,
              "lon": -76.62375,
              "departureTime": 1729649018000,
              "arrivalTime": 1729649018000
            }
          }
        ]
      }
    },
    {
      "GEOID": 24510271200,
      "itineraries": {
        "startTime": 1729647189000,
        "endTime": 1729650053000,
        "legs": [
          {
            "mode": "WALK",
            "startTime": 1729647189000,
            "endTime": 1729647991000,
            "from": {
              "lat": 39.3682197,
              "lon": -76.6213669,
              "departureTime": 1729647189000,
              "arrivalTime": 1729647189000
            },
            "to": {
              "lat": 39.367133,
              "lon": -76.60996,
              "departureTime": 1729647991000,
              "arrivalTime": 1729647991000
            }
          },
          {
            "mode": "BUS",
            "startTime": 1729647991000,
            "endTime": 1729649880000,
            "from": {
              "lat": 39.367133,
              "lon": -76.60996,
              "departureTime": 1729647991000,
              "arrivalTime": 1729647991000
            },
            "to": {
              "lat": 39.289133,
              "lon": -76.623864,
              "departureTime": 1729649880000,
              "arrivalTime": 1729649880000
            }
          },
          {
            "mode": "WALK",
            "startTime": 1729649880000,
            "endTime": 1729650053000,
            "from": {
              "lat": 39.289133,
              "lon": -76.623864,
              "departureTime": 1729649880000,
              "arrivalTime": 1729649880000
            },
            "to": {
              "lat": 39.28749,
              "lon": -76.62375,
              "departureTime": 1729650053000,
              "arrivalTime": 1729650053000
            }
          }
        ]
      }
    },
    {
      "GEOID": 24510140100,
      "itineraries": {
        "startTime": 1729646595000,
        "endTime": 1729648012000,
        "legs": [
          {
            "mode": "WALK",
            "startTime": 1729646595000,
            "endTime": 1729647480000,
            "from": {
              "lat": 39.3084231,
              "lon": -76.6236709,
              "departureTime": 1729646595000,
              "arrivalTime": 1729646595000
            },
            "to": {
              "lat": 39.300889,
              "lon": -76.622688,
              "departureTime": 1729647480000,
              "arrivalTime": 1729647480000
            }
          },
          {
            "mode": "BUS",
            "startTime": 1729647480000,
            "endTime": 1729647720000,
            "from": {
              "lat": 39.300889,
              "lon": -76.622688,
              "departureTime": 1729647480000,
              "arrivalTime": 1729647480000
            },
            "to": {
              "lat": 39.288762,
              "lon": -76.621013,
              "departureTime": 1729647720000,
              "arrivalTime": 1729647720000
            }
          },
          {
            "mode": "WALK",
            "startTime": 1729647720000,
            "endTime": 1729648012000,
            "from": {
              "lat": 39.288762,
              "lon": -76.621013,
              "departureTime": 1729647720000,
              "arrivalTime": 1729647720000
            },
            "to": {
              "lat": 39.28749,
              "lon": -76.62375,
              "departureTime": 1729648012000,
              "arrivalTime": 1729648012000
            }
          }
        ]
      }
    },
    {
        "GEOID": 24510090600,
"itineraries":
        {
          "startTime": 1729648126000,
          "endTime": 1729650282000,
          "legs": [
            {
              "mode": "WALK",
              "startTime": 1729648126000,
              "endTime": 1729648483000,
              "from": {
                "lat": 39.324094,
                "lon": -76.5922778,
                "departureTime": 1729648126000,
                "arrivalTime": 1729648126000
              },
              "to": {
                "lat": 39.324063,
                "lon": -76.596234,
                "departureTime": 1729648483000,
                "arrivalTime": 1729648483000
              }
            },
            {
              "mode": "BUS",
              "startTime": 1729648483000,
              "endTime": 1729649450000,
              "from": {
                "lat": 39.324063,
                "lon": -76.596234,
                "departureTime": 1729648483000,
                "arrivalTime": 1729648483000
              },
              "to": {
                "lat": 39.288717,
                "lon": -76.613857,
                "departureTime": 1729649450000,
                "arrivalTime": 1729649450000
              }
            },
            {
              "mode": "WALK",
              "startTime": 1729649450000,
              "endTime": 1729649579000,
              "from": {
                "lat": 39.288717,
                "lon": -76.613857,
                "departureTime": 1729649450000,
                "arrivalTime": 1729649450000
              },
              "to": {
                "lat": 39.28788,
                "lon": -76.613375,
                "departureTime": 1729649579000,
                "arrivalTime": 1729649579000
              }
            },
            {
              "mode": "BUS",
              "startTime": 1729650052000,
              "endTime": 1729650251000,
              "from": {
                "lat": 39.28788,
                "lon": -76.613375,
                "departureTime": 1729650052000,
                "arrivalTime": 1729650052000
              },
              "to": {
                "lat": 39.287503,
                "lon": -76.623267,
                "departureTime": 1729650251000,
                "arrivalTime": 1729650251000
              }
            },
            {
              "mode": "WALK",
              "startTime": 1729650251000,
              "endTime": 1729650282000,
              "from": {
                "lat": 39.287503,
                "lon": -76.623267,
                "departureTime": 1729650251000,
                "arrivalTime": 1729650251000
              },
              "to": {
                "lat": 39.28749,
                "lon": -76.62375,
                "departureTime": 1729650282000,
                "arrivalTime": 1729650282000
              }
            }]}
        },
{
"GEOID": 24510160801,
      "itineraries":
        {
          "startTime": 1729729348000,
          "endTime": 1729731287000,
          "legs": [
            {
              "mode": "WALK",
              "startTime": 1729729348000,
              "endTime": 1729729807000,
              "from": {
                "lat": 39.2965958,
                "lon": -76.682167,
                "departureTime": 1729729348000,
                "arrivalTime": 1729729348000
              },
              "to": {
                "lat": 39.293585,
                "lon": -76.684574,
                "departureTime": 1729729807000,
                "arrivalTime": 1729729807000
              }
            },
            {
              "mode": "BUS",
              "startTime": 1729729807000,
              "endTime": 1729730725000,
              "from": {
                "lat": 39.293585,
                "lon": -76.684574,
                "departureTime": 1729729807000,
                "arrivalTime": 1729729807000
              },
              "to": {
                "lat": 39.292705,
                "lon": -76.622656,
                "departureTime": 1729730725000,
                "arrivalTime": 1729730725000
              }
            },
            {
              "mode": "WALK",
              "startTime": 1729730725000,
              "endTime": 1729731287000,
              "from": {
                "lat": 39.292705,
                "lon": -76.622656,
                "departureTime": 1729730725000,
                "arrivalTime": 1729730725000
              },
              "to": {
                "lat": 39.28749,
                "lon": -76.62375,
                "departureTime": 1729731287000,
                "arrivalTime": 1729731287000
              }
            }
          ]
        }
},
{
"GEOID": 24510010300,
"itineraries":
        {
          "startTime": 1729730272000,
          "endTime": 1729731451000,
          "legs": [
            {
              "mode": "WALK",
              "startTime": 1729730272000,
              "endTime": 1729730540000,
              "from": {
                "lat": 39.2846245,
                "lon": -76.5822119,
                "departureTime": 1729730272000,
                "arrivalTime": 1729730272000
              },
              "to": {
                "lat": 39.286044,
                "lon": -76.58411,
                "departureTime": 1729730540000,
                "arrivalTime": 1729730540000
              }
            },
            {
              "mode": "BUS",
              "startTime": 1729730540000,
              "endTime": 1729731420000,
              "from": {
                "lat": 39.286044,
                "lon": -76.58411,
                "departureTime": 1729730540000,
                "arrivalTime": 1729730540000
              },
              "to": {
                "lat": 39.287503,
                "lon": -76.623267,
                "departureTime": 1729731420000,
                "arrivalTime": 1729731420000
              }
            },
            {
              "mode": "WALK",
              "startTime": 1729731420000,
              "endTime": 1729731451000,
              "from": {
                "lat": 39.287503,
                "lon": -76.623267,
                "departureTime": 1729731420000,
                "arrivalTime": 1729731420000
              },
              "to": {
                "lat": 39.28749,
                "lon": -76.62375,
                "departureTime": 1729731451000,
                "arrivalTime": 1729731451000
              }
            }
          ]
        }
},
{
"GEOID": 24510060300,
"itineraries":
        {
          "startTime": 1729730255000,
          "endTime": 1729731657000,
          "legs": [
            {
              "mode": "WALK",
              "startTime": 1729730255000,
              "endTime": 1729730930000,
              "from": {
                "lat": 39.2945199,
                "lon": -76.584662,
                "departureTime": 1729730255000,
                "arrivalTime": 1729730255000
              },
              "to": {
                "lat": 39.294171,
                "lon": -76.594182,
                "departureTime": 1729730930000,
                "arrivalTime": 1729730930000
              }
            },
            {
              "mode": "BUS",
              "startTime": 1729730930000,
              "endTime": 1729731626000,
              "from": {
                "lat": 39.294171,
                "lon": -76.594182,
                "departureTime": 1729730930000,
                "arrivalTime": 1729730930000
              },
              "to": {
                "lat": 39.287503,
                "lon": -76.623267,
                "departureTime": 1729731626000,
                "arrivalTime": 1729731626000
              }
            },
            {
              "mode": "WALK",
              "startTime": 1729731626000,
              "endTime": 1729731657000,
              "from": {
                "lat": 39.287503,
                "lon": -76.623267,
                "departureTime": 1729731626000,
                "arrivalTime": 1729731626000
              },
              "to": {
                "lat": 39.28749,
                "lon": -76.62375,
                "departureTime": 1729731657000,
                "arrivalTime": 1729731657000
              }
            }
          ]
        }
},
{
"GEOID": 24510260203,
"itineraries":
        {
          "startTime": 1729731169000,
          "endTime": 1729734412000,
          "legs": [
            {
              "mode": "WALK",
              "startTime": 1729731169000,
              "endTime": 1729731544000,
              "from": {
                "lat": 39.3269392,
                "lon": -76.5404207,
                "departureTime": 1729731169000,
                "arrivalTime": 1729731169000
              },
              "to": {
                "lat": 39.323805,
                "lon": -76.54119,
                "departureTime": 1729731544000,
                "arrivalTime": 1729731544000
              }
            },
            {
              "mode": "BUS",
              "startTime": 1729731544000,
              "endTime": 1729733454000,
              "from": {
                "lat": 39.323805,
                "lon": -76.54119,
                "departureTime": 1729731544000,
                "arrivalTime": 1729731544000
              },
              "to": {
                "lat": 39.29842,
                "lon": -76.621312,
                "departureTime": 1729733454000,
                "arrivalTime": 1729733454000
              }
            },
            {
              "mode": "WALK",
              "startTime": 1729733454000,
              "endTime": 1729733516000,
              "from": {
                "lat": 39.29842,
                "lon": -76.621312,
                "departureTime": 1729733454000,
                "arrivalTime": 1729733454000
              },
              "to": {
                "lat": 39.299015,
                "lon": -76.621599,
                "departureTime": 1729733516000,
                "arrivalTime": 1729733516000
              }
            },
            {
              "mode": "BUS",
              "startTime": 1729733932000,
              "endTime": 1729734120000,
              "from": {
                "lat": 39.299015,
                "lon": -76.621599,
                "departureTime": 1729733932000,
                "arrivalTime": 1729733932000
              },
              "to": {
                "lat": 39.288762,
                "lon": -76.621013,
                "departureTime": 1729734120000,
                "arrivalTime": 1729734120000
              }
            },
            {
              "mode": "WALK",
              "startTime": 1729734120000,
              "endTime": 1729734412000,
              "from": {
                "lat": 39.288762,
                "lon": -76.621013,
                "departureTime": 1729734120000,
                "arrivalTime": 1729734120000
              },
              "to": {
                "lat": 39.28749,
                "lon": -76.62375,
                "departureTime": 1729734412000,
                "arrivalTime": 1729734412000
              }
            }
          ]
        }
},
{
"GEOID": 24510270701,
"itineraries":
        {
          "startTime": 1729731559000,
          "endTime": 1729734665000,
          "legs": [
            {
              "mode": "WALK",
              "startTime": 1729731559000,
              "endTime": 1729731720000,
              "from": {
                "lat": 39.3712376,
                "lon": -76.5688509,
                "departureTime": 1729731559000,
                "arrivalTime": 1729731559000
              },
              "to": {
                "lat": 39.370974,
                "lon": -76.56711,
                "departureTime": 1729731720000,
                "arrivalTime": 1729731720000
              }
            },
            {
              "mode": "BUS",
              "startTime": 1729731720000,
              "endTime": 1729734330000,
              "from": {
                "lat": 39.370974,
                "lon": -76.56711,
                "departureTime": 1729731720000,
                "arrivalTime": 1729731720000
              },
              "to": {
                "lat": 39.287717,
                "lon": -76.618978,
                "departureTime": 1729734330000,
                "arrivalTime": 1729734330000
              }
            },
            {
              "mode": "WALK",
              "startTime": 1729734330000,
              "endTime": 1729734665000,
              "from": {
                "lat": 39.287717,
                "lon": -76.618978,
                "departureTime": 1729734330000,
                "arrivalTime": 1729734330000
              },
              "to": {
                "lat": 39.28749,
                "lon": -76.62375,
                "departureTime": 1729734665000,
                "arrivalTime": 1729734665000
              }
            }
          ]
        }
},
{
"GEOID": 24510090500,
"itineraries":
        {
          "startTime": 1729730471000,
          "endTime": 1729732625000,
          "legs": [
            {
              "mode": "WALK",
              "startTime": 1729730471000,
              "endTime": 1729731282000,
              "from": {
                "lat": 39.3250391,
                "lon": -76.6023316,
                "departureTime": 1729730471000,
                "arrivalTime": 1729730471000
              },
              "to": {
                "lat": 39.319308,
                "lon": -76.592794,
                "departureTime": 1729731282000,
                "arrivalTime": 1729731282000
              }
            },
            {
              "mode": "BUS",
              "startTime": 1729731282000,
              "endTime": 1729732290000,
              "from": {
                "lat": 39.319308,
                "lon": -76.592794,
                "departureTime": 1729731282000,
                "arrivalTime": 1729731282000
              },
              "to": {
                "lat": 39.287717,
                "lon": -76.618978,
                "departureTime": 1729732290000,
                "arrivalTime": 1729732290000
              }
            },
            {
              "mode": "WALK",
              "startTime": 1729732290000,
              "endTime": 1729732625000,
              "from": {
                "lat": 39.287717,
                "lon": -76.618978,
                "departureTime": 1729732290000,
                "arrivalTime": 1729732290000
              },
              "to": {
                "lat": 39.28749,
                "lon": -76.62375,
                "departureTime": 1729732625000,
                "arrivalTime": 1729732625000
              }
            }
          ]
        }
},
{
"GEOID": 24510190300,
"itineraries":
        {
          "startTime": 1729730634000,
          "endTime": 1729731485000,
          "legs": [
            {
              "mode": "WALK",
              "startTime": 1729730634000,
              "endTime": 1729730791000,
              "from": {
                "lat": 39.2864009,
                "lon": -76.6461701,
                "departureTime": 1729730634000,
                "arrivalTime": 1729730634000
              },
              "to": {
                "lat": 39.285181,
                "lon": -76.645146,
                "departureTime": 1729730791000,
                "arrivalTime": 1729730791000
              }
            },
            {
              "mode": "BUS",
              "startTime": 1729730791000,
              "endTime": 1729731244000,
              "from": {
                "lat": 39.285181,
                "lon": -76.645146,
                "departureTime": 1729730791000,
                "arrivalTime": 1729730791000
              },
              "to": {
                "lat": 39.289085,
                "lon": -76.624884,
                "departureTime": 1729731244000,
                "arrivalTime": 1729731244000
              }
            },
            {
              "mode": "WALK",
              "startTime": 1729731244000,
              "endTime": 1729731485000,
              "from": {
                "lat": 39.289085,
                "lon": -76.624884,
                "departureTime": 1729731244000,
                "arrivalTime": 1729731244000
              },
              "to": {
                "lat": 39.28749,
                "lon": -76.62375,
                "departureTime": 1729731485000,
                "arrivalTime": 1729731485000
              }
            }
          ]
        }
      }
     
  ]
}

  


export default routes;